export default {
    init() {
        $(document).on("change", "[data-task-list-select]", function () {
            const form = $(this).closest("form");
            const privateList = Number($(this).find("option:selected").data("private")) === 1;
            const assigneeField = form.find("[data-task-assignee-field]");

            assigneeField.prop("hidden", privateList);
            assigneeField.find("select").prop("disabled", privateList);
            if (privateList) assigneeField.find("select").val("");
        });
    },
};
